function devtricker_dom_set_recoverAccountClearError() {
    const resetError = document.getElementById('requestRecoveryError');
    const resetSuccess = document.getElementById('requestRecoverySuccess');

    resetError.style.display = 'none';
    resetSuccess.style.display = 'none';
}

function devtricker_dom_set_changeTheContinueButtonToLoading(button, loadingText) {
    button.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ${loadingText}`;
    button.disabled = true;
}

function devtricker_dom_set_changeTheContinueButtonToLoadig() {

    const resetForm = document.querySelector('#dev-tricker-recover-account-modal form');

    const resetButton = resetForm.querySelector('button[type="submit"]');

    resetButton.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ${g_devtricker_i18n.sending}`;
    resetButton.disabled = true;
}

function devtricker_dom_set_restoreTheContinueButtonToOriginal(button, originalText) {
    button.innerHTML = originalText;
    button.disabled = false;
}

function devtricker_dom_set_displayErrorInRecoverAccount(message) {
    displayResetFeedback(message, false);
}

function devtricker_dom_set_changeRecoverAccountButtonToGeneratingPow() {

    const resetForm = document.querySelector('#dev-tricker-recover-account-modal form');

    const resetButton = resetForm.querySelector('button[type="submit"]');

    resetButton.setAttribute('disabled', 'true');
    resetButton.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Generating PoW...`;
}


function displayResetFeedback(message, isSuccess) {
    const resetError = document.getElementById('requestRecoveryError');
    const resetSuccess = document.getElementById('requestRecoverySuccess');

    if (isSuccess) {
        resetSuccess.textContent = message;
        resetSuccess.style.display = 'block';
        resetError.style.display = 'none';
    } else {
        resetError.textContent = message;
        resetError.style.display = 'block';
        resetSuccess.style.display = 'none';
    }
}